import React from "react";
import MuiTable from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { OptionsDataType, ColDataType, RowDataType } from "./types";
import { Row } from "./table-row";
import "./table.scss";

interface TableProps<TRowData> {
  options: OptionsDataType;
  columns: ColDataType[];
  rows: TRowData[] | TRowData[][];
}

export function Table<TRowData extends RowDataType>({
  options,
  columns,
  rows,
}: TableProps<TRowData>) {
  return (
    <TableContainer
      className={`${options.tablePrefixClass ?? ""} table-container`}
    >
      <MuiTable
        className={`${options.tablePrefixClass ?? ""} table`}
        stickyHeader={options.headerSticky ?? false}
        aria-label={options.tableAriaLabel}
      >
        <TableHead className={`${options.tablePrefixClass ?? ""} table__head`}>
          {options.headerEl && (
            <TableRow
              className={`${options.tablePrefixClass ?? ""} table__head__title`}
            >
              <TableCell colSpan={columns.length}>{options.headerEl}</TableCell>
            </TableRow>
          )}
          {!options.headerColTitlesDisabled && (
            <TableRow
              className={`${
                options.tablePrefixClass ?? ""
              } table__head__col-titles`}
            >
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  style={{
                    top:
                      options.headerSticky &&
                      options.headerEl &&
                      options.headerColTopOffset
                        ? options.headerColTopOffset
                        : "inital",
                  }}
                  align={column.align}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          )}
        </TableHead>

        <TableBody className={`${options.tablePrefixClass ?? ""} table__body`}>
          {rows.map((row, index) => {
            if (Array.isArray(row)) {
              return row.map((rowObj, index) => {
                return (
                  <Row
                    key={index}
                    row={rowObj}
                    columns={columns}
                    tablePrefixClass={options.tablePrefixClass}
                  />
                );
              });
            }

            return (
              <Row
                key={index}
                row={row}
                columns={columns}
                tablePrefixClass={options.tablePrefixClass}
              />
            );
          })}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
}
